export const loadingShimmerContainerCss = {
  width: "100%",
  height: "30px",
};
